/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_a8118623',
  dropdown: 'dropdown_a8118623',
};

export = styles;

loadStyles([{"rawString":".root_a8118623{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_a8118623 .dropdown_a8118623{margin-bottom:0;margin-left:5px}"}]);
/* tslint:enable */